var Tour = {};

// Версия плеера
Tour.version = [2, 2, 5];
